var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMastodon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    rx: 9,
    fill: "#6364FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_100424_443010)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3925 12.1462C12.9045 11.9662 14.22 11.04 14.385 10.194C14.646 8.8605 14.625 6.93975 14.625 6.93975C14.625 4.33725 12.9105 3.57375 12.9105 3.57375C12.0465 3.1785 10.5623 3.01275 9.02028 3H8.98278C7.44003 3.01275 5.95653 3.1785 5.09253 3.57375C5.09253 3.57375 3.37878 4.3365 3.37878 6.93975L3.37728 7.43625C3.37428 7.91625 3.37203 8.44875 3.38553 9.0045C3.44778 11.55 3.85503 14.0595 6.22053 14.682C7.31103 14.9692 8.24778 15.0293 9.00228 14.988C10.3695 14.913 11.1375 14.5028 11.1375 14.5028L11.0925 13.515C11.0925 13.515 10.1153 13.8225 9.01728 13.785C7.92978 13.7475 6.78228 13.668 6.60603 12.339C6.59008 12.2156 6.58181 12.0914 6.58128 11.967C6.58128 11.967 7.64928 12.2265 9.00228 12.288C9.82953 12.3255 10.605 12.24 11.3933 12.1462H11.3925ZM12.6023 10.2938H11.3475V7.23375C11.3475 6.5895 11.0745 6.2625 10.5293 6.2625C9.92628 6.2625 9.62403 6.65025 9.62403 7.41825V9.093H8.37603V7.4175C8.37603 6.6495 8.07378 6.26175 7.47078 6.26175C6.92553 6.26175 6.65253 6.58875 6.65253 7.23375V10.293H5.39778V7.1415C5.39778 6.4975 5.56278 5.986 5.89278 5.607C6.23478 5.22825 6.68178 5.034 7.23753 5.034C7.87953 5.034 8.36553 5.28 8.68728 5.77125L9.00003 6.2925L9.31278 5.77125C9.63453 5.28 10.1205 5.034 10.7633 5.034C11.3183 5.034 11.7653 5.22825 12.1065 5.607C12.4375 5.9855 12.6028 6.497 12.6023 7.1415V10.2938Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_100424_443010"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(3 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastodon);
export default __webpack_public_path__ + "static/media/mastodon.bd2f6c8d4be199012bb078b02aeb6b3a.svg";
export { ForwardRef as ReactComponent };